import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login/login.component';
import { HomeComponent } from './home/home.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { SideMenuComponent } from './layout/side-menu/side-menu.component'
import { FullComponent } from './layout/full.component';


//Importacions Angular material
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatGridListModule } from '@angular/material/grid-list';

import { InterceptorService } from './core/auth/interceptor.service';
import { ReactiveFormsModule } from '@angular/forms';
import { getDutchPaginatorIntl } from './utils/traslate/traslate-paginator';

import { DatePipe } from '@angular/common';
import { OrdenarPipe } from './utils/Pipe/ordenar.pipe';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ResponseInterceptorService } from './core/auth/response-interceptor.service';
import { NuevoSideComponent } from './layout/nuevo-side/nuevo-side.component';
import { PipeModule } from './core/pipe/pipe.module';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { environment } from '../environments/environment';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule, provideNativeDateAdapter } from '@angular/material/core';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
const config: SocketIoConfig = { url: environment.wsUrl };

export const MI_FORMATO_FECHA = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@NgModule({
    declarations: [
        AppComponent,
        FullComponent,
        LoginComponent,
        HomeComponent,
        NavbarComponent,
        SideMenuComponent,
        OrdenarPipe,
        NuevoSideComponent
    ],
    exports: [
        MatProgressSpinnerModule,
        SharedModule,
        PipeModule
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        MatToolbarModule,
        MatIconModule,
        MatSidenavModule,
        AppRoutingModule,
        ToastrModule,
        MatExpansionModule,
        MatCardModule,
        MatListModule,
        SharedModule,
        MatMenuModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatGridListModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        ToastrModule.forRoot(),
        SocketIoModule.forRoot(config),
        MatDatepickerModule,
        MatNativeDateModule,
        
    ],
    providers: [
        DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ResponseInterceptorService,
            multi: true
        },
        { provide: MatPaginatorIntl, useValue: getDutchPaginatorIntl() },
        provideHttpClient(withInterceptorsFromDi()),
        provideCharts(withDefaultRegisterables()),
        provideNativeDateAdapter(),
        { provide: MAT_DATE_LOCALE, useValue: 'es-HN' },
        { provide: MAT_DATE_FORMATS, useValue: MI_FORMATO_FECHA },
    ]
})
export class AppModule { }
